import Slider from 'react-slick'
import { merge } from 'lodash'
import Link from 'next/link'

function RelatedSlider(props) {
    const settings = merge(
        {},
        {
            items: [],
            dots: false,
            infinite: false,
            slidesToShow: 5,
            slidesToScroll: 1,
            rtl: false,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        initialSlide: 2
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        },
        props
    )

    return (
        <Slider {...settings}>
            {settings.items.map((i, idx) => (
                <div key={idx} className="imgItem">
                    <Link href={`/products/detail/${i.id}/${encodeURIComponent(i.name)}`}>
                        <a className="">
                            <img
                                src={`/api/${i.metas?.pic_path?.value}` || '/img/pic.jpg'}
                                className="rounded-lg mx-auto shadow-md w-40 h-40 "
                                alt={i.name}
                            />
                        </a>
                    </Link>
                </div>
            ))}
        </Slider>
    )
}

export { RelatedSlider }
